import styled, { createGlobalStyle } from 'styled-components';

import { fontFamilyBase, fontWeightMedium } from './typography.style';
import { mediaUp } from 'approot/shared/style';
import { ReactModalCss } from 'lib/modal/modal.style';
import { PrintCss } from './print.style';
import { RebootCss } from './reboot.style';
import { ProductTourAnimationCss } from 'approot/shared/product-tours/product-tour-animation.style';

export const GlobalStyles = createGlobalStyle`
  /* Declare the cascade-layer order: our Bootstrap Reboot sits in the lowest
     layer, with Astryx's layers (reset -> astryx-base -> astryx-theme) above
     it, so Astryx styles win. Unlayered styles (e.g. styled-components) still
     take precedence over anything in a layer, as before. */
  @layer inq-reboot, reset, astryx-base, astryx-theme;

  html,
  body {
    font-family: ${fontFamilyBase};
    min-width: 280px;
  }

  html {
    min-height: 100%;
  }

  body {
    overflow-x: hidden;
  }

  strong {
    font-weight: ${fontWeightMedium};
  }

  ${ReactModalCss}
  ${PrintCss}

  @layer inq-reboot {
    ${RebootCss}
  }

  ${ProductTourAnimationCss}
`;

export const ScreenReaderOnly = styled.div`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const ScreenSmallOnlyStyled = styled.span`
  display: block;
  ${mediaUp.md`
    display: none;
  `}
`;

export const ScreenMediumOnlyStyled = styled.span`
  display: none;
  ${mediaUp.md`
    display: block;
  `}
`;
